import React, { useEffect } from 'react';
import { isIPhoneTopLevel } from '../utils/iosSafariBars';
import { FaVolumeUp, FaVolumeMute, FaExpand, FaCompress, FaInfoCircle, FaUsers } from 'react-icons/fa';
import { BsMicFill, BsMicMuteFill } from 'react-icons/bs';
import { IoIosChatboxes } from 'react-icons/io';
import { GiVrHeadset } from 'react-icons/gi';
import { Badge } from 'react-bootstrap';
import ResolutionModalButton from '../ResolutionModalButton';
import EncodingQualityIcon from './EncodingQualityIcon';
import { styles } from '../constants/streamConstants';

const ControlPanel = ({
  project,
  showChatUiMobile,
  showChatUI,
  roomDisconnect,
  isMobile,
  showChatUiDesktop,
  someoneTyping,
  newMessage,
  sdkConnect,
  toggleMicChat,
  handleMicChat,
  isMuted,
  toggleSound,
  isFullscreen,
  toggleFullscreen,
  activeResolution,
  PixelStreamingUiApp,
  resolutionSetting,
  handleResMax,
  toggleStats,
  avgQp,
  primaryCodec,
  xrSupport,
  toggleXR,
  openChatUiMobile,
  openChatUiDesktop,
}) => {



  return (
    <div
      className="controlPanel"
      style={{
        ...(project.chatPosition === "Left"
          ? { right: "max(20px, env(safe-area-inset-right))", flexDirection: "row" }
          : { left: "max(20px, env(safe-area-inset-left))", flexDirection: "row-reverse" }),
      }}
    >
      {(!showChatUiMobile && showChatUI && !roomDisconnect && isMobile && project.textChat) && (
        <div className="button-wrapper">
          <button style={styles.button} onClick={openChatUiMobile}>
            <IoIosChatboxes size={20} />
          </button>
          {someoneTyping ? (
            <span className="typing-badge" aria-label="Someone is typing">
              <span /><span /><span />
            </span>
          ) : newMessage > 0 && (
            <Badge bg="danger" className="notification-badge">{newMessage}</Badge>
          )}
        </div>
      )}

      {(!isMobile && !showChatUiDesktop && showChatUI && !roomDisconnect && (project.textChat || project.voiceChat)) && (
        <div className="button-wrapper">
          <button
            style={styles.button}
            onClick={openChatUiDesktop}
            title={project.textChat ? 'Open chat' : 'Open people'}
          >
            {project.textChat
              ? <IoIosChatboxes size={20} />
              : <FaUsers size={20} />}
          </button>
          {project.textChat && someoneTyping ? (
            <span className="typing-badge" aria-label="Someone is typing">
              <span /><span /><span />
            </span>
          ) : newMessage > 0 && (
            <Badge bg="danger" className="notification-badge">{newMessage}</Badge>
          )}
        </div>
      )}

      {(showChatUiMobile && isMobile) ? null : (
        <>
          {(project?.voiceChat && showChatUI && !roomDisconnect && sdkConnect) && (
            <button
              style={styles.button}
              onClick={handleMicChat}
              title={toggleMicChat ? 'Mute microphone' : 'Unmute microphone'}
            >
              {toggleMicChat ? <BsMicFill size={20} /> : <BsMicMuteFill size={20} />}
            </button>
          )}

          {project?.showBtnVolume && (
            <button
              style={styles.button}
              onClick={toggleSound}
              title={isMuted ? 'Unmute audio' : 'Mute audio'}
            >
              {isMuted ? <FaVolumeMute size={20} /> : <FaVolumeUp size={20} />}
            </button>
          )}
          {/* iPhone: no element fullscreen exists, so the button is replaced by the swipe-up prompt (App.js). */}
          {project?.showBtn && !isIPhoneTopLevel() && (
            <button
              style={styles.button}
              onClick={toggleFullscreen}
              title={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
            >
              {isFullscreen ? <FaCompress size={20} /> : <FaExpand size={20} />}
            </button>
          )}
          {project?.showBtnResolution && (
            <ResolutionModalButton
              chatPosition={project.chatPosition}
              activeResolution={activeResolution}
              PixelStreamingUiApp={PixelStreamingUiApp}
              resolutionSetting={resolutionSetting}
              handleResMax={handleResMax}
            />
          )}
          {project?.showBtnInfo && (
            <button style={styles.button} onClick={toggleStats}>
              <FaInfoCircle size={20} />
            </button>
          )}
          {project.showNetwork && (
            <button style={styles.button} disabled>
              <EncodingQualityIcon avgQp={avgQp} size={20} position={project.chatPosition} codec={primaryCodec} />
            </button>
          )}
          {xrSupport && project?.xrInput && (
            <button style={styles.button} onClick={toggleXR}>
              <GiVrHeadset size={20} />
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default ControlPanel;
